import { SUPPORTED_UNITS } from '@schuettflix/interfaces';

export const SUPPORTED_UNIT_LABEL = {
    DAY: 'unitShortName.day',
    HOUR: 'unitShortName.hour',
    KILOMETER: 'unitShortName.kilometer',
    KILOGRAM: 'unitShortName.kilogram',
    TON: 'unitShortName.ton',
    CUBIC_METER: 'unitShortName.cubicMeter',
    LITER: 'unitShortName.liter',
    PIECE: 'unitShortName.piece',
    TRANSPORT: 'unitShortName.transport',
    FLAT_RATE: 'unitShortName.flatRate',
    MINUTE: 'unitShortName.minute',
} as const satisfies Record<SUPPORTED_UNITS, string>;

export const SUPPORTED_UNIT_LABEL_LONG = {
    ...SUPPORTED_UNIT_LABEL,
    TON: 'unitLongName.ton',
    TRANSPORT: 'unitLongName.transport',
} as const;
